/**
 * The clay illustrations the inside pages may use (docs/v2-core/STYLE.md).
 * They are the landing page's own files — bundled by Vite, never hot-linked.
 * Every one is a transparent cut-out, so it sits straight on a wash.
 *
 * `max` is the widest CSS size to render it at (half its pixel width), so
 * it stays sharp on a 2x screen.
 */
import heroFamily from "../assets/landing/hero-family.webp";
import ctaFamily from "../assets/landing/cta-family.webp";
import circleFamily from "../assets/landing/circle-family.webp";
import listMom from "../assets/landing/list-mom.webp";
import stepList from "../assets/landing/step-list.webp";
import stepChoose from "../assets/landing/step-choose.webp";
import stepSend from "../assets/landing/step-send.webp";
import privacyLock from "../assets/landing/privacy-lock.webp";
import feedbackBubble from "../assets/landing/feedback-bubble.webp";

export type ClayArtName =
  | "family"
  | "familyWave"
  | "hug"
  | "momList"
  | "list"
  | "controls"
  | "send"
  | "lock"
  | "heart";

export interface ClayArtInfo {
  src: string;
  width: number;
  height: number;
  /** Widest CSS width (px) that stays sharp at 2x. */
  max: number;
  /** What it shows — for picking art, not alt text (the art is decorative). */
  about: string;
}

export const CLAY_ART: Record<ClayArtName, ClayArtInfo> = {
  family: { src: heroFamily, width: 1000, height: 1000, max: 500, about: "The whole family and their dog" },
  familyWave: { src: ctaFamily, width: 1040, height: 691, max: 520, about: "Everyone waving hello" },
  hug: { src: circleFamily, width: 440, height: 440, max: 220, about: "A family hug, in a circle" },
  momList: { src: listMom, width: 760, height: 950, max: 380, about: "Mom and little one with the list" },
  list: { src: stepList, width: 320, height: 320, max: 160, about: "A phone showing a child's list" },
  controls: { src: stepChoose, width: 320, height: 320, max: 160, about: "Toggles — choosing what to share" },
  send: { src: stepSend, width: 320, height: 320, max: 160, about: "A paper plane carrying a link" },
  lock: { src: privacyLock, width: 560, height: 560, max: 280, about: "A friendly lock and shield" },
  heart: { src: feedbackBubble, width: 360, height: 360, max: 180, about: "A speech bubble with a heart" },
};
